import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=6f648ad9&scoped=true"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BaseAutocomplete.vue?vue&type=style&index=0&id=6f648ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f648ad9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
